import WebStorageCache from "web-storage-cache";

var user = {
  wsCache: new WebStorageCache(),
  // 获取用户数据
  getUserInfo(callback, islogin) {
    let User = {};
    User.token = "";
    User.user_id = "17002191758";
    User.mac = "";
    User.sn = "";
    User.cnn = "";
    User.app_version = "6.9.0";
    user.wsCache.set("UserInfo", User);
    callback && callback();
  },
};
export default user;
